import React, { useState, useCallback } from "react";
import { FormControl, RadioGroup, FormControlLabel, Radio, useTheme } from "@mui/material";
//import "./Choice.css";
import { useTranslation } from "react-i18next";

const Choice = ({ questionId, onChange, currentValue }) => {
  const [choice, setChoice] = useState(currentValue);
  const { t: res } = useTranslation();
  const theme = useTheme();

  const handleChange = useCallback(
    (e) => {
      const newValue = e.target.value;
      setChoice(newValue);
      onChange && onChange(newValue, questionId);
    },
    [onChange, questionId] // Memoized dependencies
  );

  var choice1 = res("choice_1");
  var choice2 = res("choice_2");
  var choice3 = res("choice_3");

  return (
    <FormControl component="fieldset">
      <RadioGroup
        aria-label={`choice-${questionId}`}
        name={`choice-${questionId}`}
        value={choice}
        onChange={handleChange}
        row
      >
        {[choice1, choice2, choice3].map((label, index) => (
          <FormControlLabel
            key={index}
            value={index}
            control={<Radio />}
            label={label}
            componentsProps={{
              typography: {
                //fontWeight: "900", // Applies fontWeight to the label
              },
            }}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default Choice;
